/*
AdvancedTable - Helper for rendering table
Now with object support instead of standalone array elements
This component was made to replace MagicTable.js
@author Arsena 'senndbx', 2019

Props Format:
  <AdvancedTable
    colSpan={}
    colSpanText=''
    header={[{ className, field, colSpan }]}
    body={[{ className, field }]}
    style={}
    className={}
  />
*/

import React from 'react'

const AdvancedTable = props =>
  <div className='card'>
    <table className={`table table-hover table-striped ${props.className}`} style={props.style}>
      <thead>
        <tr>
          {
            props.header.map((column, COLUMN_ITERATOR) => (
              <th colSpan={column.colSpan || 1} className={column.className || 'text-center'} key={COLUMN_ITERATOR}>{ column.field }</th>
            ))
          }
        </tr>
      </thead>
      <tbody>
        {
          props.body &&
          props.body.length > 0
            ? props.body.map((row, ROW_ITERATOR) => (
              <tr key={ROW_ITERATOR}>
                {
                  row.map((column, COLUMN_ITERATOR) => (
                    <td className={column.className || 'text-center'} key={COLUMN_ITERATOR}>
                      { column.field || '-' }
                    </td>
                  ))
                }
              </tr>
            ))
            : <tr>
              <td className='text-center' colSpan={props.colSpan}>{props.colSpanText || '- No Data -'}</td>
            </tr>
        }
      </tbody>
    </table>
  </div>

export default AdvancedTable



// WEBPACK FOOTER //
// ./src/Components/AdvancedTable.js